import { render } from "./App.vue?vue&type=template&id=031be880"
const script = {}

import "./App.vue?vue&type=style&index=0&id=031be880&lang=css"
script.render = render

export default script